// extracted by mini-css-extract-plugin
module.exports = {"root":"Root_root__1pugZ","fullScreen":"Root_fullScreen__3H8Q4","bodyHidden":"Root_bodyHidden__1pDPR"};